module.exports = __webpack_public_path__ + "img/guide.96d0b929.svg";